<template>
  <div
    class="event_box"
    draggable="true"
    :data-time="dateTime"
    :data-index="dateIndex"
    :data-event="JSON.stringify(dateEvent)"
    :style="styleVal"
    @click.stop="openEvent($event, false)"
  >
    <p class="ellipsis">{{ title }}</p>
    <div
      class="ScteListWrap"
      v-if="eventSegments.length > 0">
      <div
        v-for="(item, index) in eventSegments"
        :key="index">
        <div
          class="ScteWrap"
          :style="computedStyle(item, dateEvent.item)"
          v-if="item.segmentId != 1"
        >
          <p> {{SetSubeventName(item)}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from '@/assets/js/vueBus.js'
import { Segments } from '@/assets/js/temConfig.js'
export default {
  props: {
    dateTime: {
      type: String,
      default: ''
    },
    // 事件下标
    dateIndex: [String, Number],
    dateEvent: {
      type: Object,
      default: () => {}
    },
    styleVal: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    fixedDevice: Object,
    dynamicDevice: Object,
    events: Array,
    breakMessage: {
      type: Object,
      default: () => ({ break: false })
    }
  },
  data () {
    return {
      // 子事件
      eventSegments: []
    }
  },
  mounted () {
    if (this.dateEvent.item.eventSegments) {
      this.eventSegments =
        this.dateEvent.item.eventSegments.length > 0
          ? this.dateEvent.item.eventSegments
          : []
    }
  },
  methods: {
    // 处理子事件没有name问题
    SetSubeventName (item) {
      let Name = item.eventOperationType
      if (!Name) {
        const SegmentsFirst = Segments.filter(
          (m) => m.value == item.segmentId
        )
        Name = SegmentsFirst[0].label
      }
      return Name
    },
    // 打开创建编辑框
    openEvent (e, isDrag) {
      const event = this.dateEvent.item
      console.log(event)
      if (
        ['video', 'file', 'scte'].includes(
          event.ttype && event.ttype.toLowerCase()
        )
      ) {
        event.duration = event.endTime - event.startTime
      }
      // 弹出创建框
      Bus.$emit('popupCreateBox', {
        e,
        event,
        isDrag
      })
      // let propsData = {
      //   isDrag,
      //   event,
      //   events: this.events,
      //   fixedDevice: this.fixedDevice,
      //   dynamicDevice: this.dynamicDevice,
      // };
      // this.boxElement = new createBox(e, propsData, false);
    },
    // 计算样式
    computedStyle (item, parentItem) {
      console.log(parentItem)
      // 事件从中断开
      if (this.breakMessage.break) {
        if (this.breakMessage.timestamp >= item.timingOut) {
          return {
            height: '0px',
            display: 'none'
          }
        } else if (
          this.breakMessage.timestamp >= item.timingIn &&
          this.breakMessage.timestamp <= item.timingOut
        ) {
          const ScteTop = 0
          const ScteHeight =
            (Math.floor(item.timingOut - this.breakMessage.timestamp) / 1000) * 0.42
          return {
            height: `${ScteHeight}px`,
            top: `${ScteTop}px`,
            'background-color': item.segmentId == 5 ? '#388BE5' : null
          }
        } else {
          const ScteTop =
            (Math.floor(item.timingIn - this.breakMessage.timestamp) / 1000) * 0.42
          const ScteHeight =
            (Math.floor(item.timingOut - item.timingIn) / 1000) * 0.42
          return {
            height: `${ScteHeight}px`,
            top: `${ScteTop}px`,
            'background-color': item.segmentId == 5 ? '#388BE5' : null
          }
        }
      } else {
        const ScteTop =
          (Math.floor(item.timingIn - parentItem.startTime) / 1000) * 0.42
        const ScteHeight =
          (Math.floor(item.timingOut - item.timingIn) / 1000) * 0.42
        return {
          height: `${ScteHeight}px`,
          top: `${ScteTop}px`,
          'background-color': item.segmentId == 5 ? '#388BE5' : null
        }
      }
    }
  },
  beforeDestroy () {
    this.boxElement && this.boxElement.close()
  }
}
</script>

<style lang='less' scoped>
.event_box {
  position: relative;
  z-index: 1;
  // overflow: hidden;
  .ellipsis{
    position: relative;
    z-index: 1001;
  }
  .ScteListWrap {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1000;
    .ScteWrap {
      width: 100%;
      background-color: #333;
      color: #fff;
      text-align: center;
      font-size: 12px;
      position: absolute;
      p {
        width: 100%;
        height: 100%;
        font-size: 12px;
        line-height: 1;
        overflow: hidden;
      }
      span {
        position: absolute;
        right: 10px;
        top: 0;
        i {
          color: #fff;
        }
      }
    }
    .ScteWrap::after {
      content: "";
      border-width: 5px 10px;
      border-style: solid;
      border-color: transparent rgba(255, 255, 255) transparent transparent;
      position: absolute;
      top: -5px;
      right: -10px;
    }
    .ScteWrap::before {
      content: "";
      border-width: 5px 10px;
      border-style: solid;
      border-color: transparent transparent transparent rgba(255, 255, 255);
      position: absolute;
      bottom: -5px;
      right: -20px;
    }
  }
}
</style>
